import { SubHeadline } from '~components/Typography';
import { useModal } from '~hooks/useModal';
import { FadeInImage } from '~shared/ui/atoms/FadeInImage';

import {
	isFieldButton,
	isFieldColor,
	isFieldImage,
	isFieldSliders,
	isFieldText,
} from '../../model/guards';
import type {
	BotWizardField,
	BotWizardFieldNames,
	BotWizardValues,
} from '../../model/types';
import { CustomValueModal } from '../CustomValueModal';
import { FieldButton } from '../FieldButton';
import { FieldColor } from '../FieldColor';
import { FieldImage } from '../FieldImage';
import { FieldSliders } from '../FieldSliders';
import { FieldText } from '../FieldText';
import { image, Wrapper } from './styles';

export const Field = ({
	field,
	values,
	id,
	customValues,
	nameError,
	disabled,
}: {
	id: BotWizardFieldNames;
	field: BotWizardField;
	values: BotWizardValues;
	customValues: { [key in BotWizardFieldNames]?: string };
	nameError?: string;
	disabled?: boolean;
}) => {
	const { open, isOpen, close } = useModal();
	return (
		<>
			<Wrapper>
				<SubHeadline size="M">{field.title}</SubHeadline>
				{field.image && (
					<FadeInImage
						className={image}
						src={field.image}
						alt={field.title}
						width={400}
						height={400}
					/>
				)}
				{isFieldButton(field) && (
					<FieldButton
						customValues={customValues}
						openModal={open()}
						values={values}
						id={id}
						{...field}
					/>
				)}
				{isFieldImage(field) && (
					<FieldImage
						customValues={customValues}
						openModal={open()}
						values={values}
						id={id}
						{...field}
					/>
				)}
				{isFieldColor(field) && (
					<FieldColor values={values} id={id} {...field} />
				)}
				{isFieldText(field) && (
					<FieldText
						disabled={disabled}
						nameError={nameError}
						values={values}
						id={id}
						{...field}
					/>
				)}
				{isFieldSliders(field) && (
					<FieldSliders values={values} id={id} {...field} />
				)}
			</Wrapper>
			<CustomValueModal open={isOpen} onClose={close} field={field} />
		</>
	);
};
